var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FormSubmitPopup", {
    attrs: { title: _vm.$t("stowHistory"), hideRgtBtn: "", medium: "" },
    on: {
      popupClose: function($event) {
        return _vm.$emit("input", false)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function() {
          return [
            _c(
              "v-container",
              [
                _c("PaginationController", {
                  attrs: {
                    getDataActionName: "getStowHistory",
                    historyLimit: 25,
                    searchBoxLabel: _vm.$t(
                      "searchBy UPC/Operator/Inbound time"
                    ),
                    haveSearchBox: "",
                    showSearchBoxLabel: "",
                    haveStartDate: ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "dataTable",
                      fn: function() {
                        return [
                          _c("v-data-table", {
                            staticClass: "elevation-2 myDense",
                            attrs: {
                              headers: _vm.headers,
                              items: _vm.items,
                              "item-key": "_key"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "items",
                                fn: function(ref) {
                                  var item = ref.item
                                  return [
                                    _c("td", [_vm._v(_vm._s(item.dateKeyStr))]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "text-xs-left" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getDateString(item.createTime)
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [_vm._v(_vm._s(item.operator))]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(_vm.getSiteName(item.siteKey))
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-left" },
                                      _vm._l(item.stowList, function(detail) {
                                        return _c(
                                          "div",
                                          { key: detail.upc },
                                          [
                                            _c(
                                              "v-layout",
                                              [
                                                _c(
                                                  "v-flex",
                                                  { attrs: { md4: "" } },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("upc") +
                                                          ": " +
                                                          detail.upc
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-flex",
                                                  { attrs: { md4: "" } },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("stowQty") +
                                                          ": " +
                                                          detail.stowQty
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-flex",
                                                  { attrs: { md4: "" } },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("unstowedQty") +
                                                          ": " +
                                                          detail.unstowedQty
                                                      )
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      }),
                                      0
                                    )
                                  ]
                                }
                              }
                            ])
                          })
                        ]
                      },
                      proxy: true
                    }
                  ]),
                  model: {
                    value: _vm.items,
                    callback: function($$v) {
                      _vm.items = $$v
                    },
                    expression: "items"
                  }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f267ed1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f267ed1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StowHistoryPopup.vue
// module id = null
// module chunks = 